import React, { useMemo, useState } from 'react';
import { Dropdown, Loader } from 'semantic-ui-react';
import { SatCoreRegister } from '../SatCoreRegistry';
import '../css/NestedDropdown.less';

const convertToLinearOptions = (options, level = 1) => options.reduce((result, { children, className, ...option }) => {
  result.push({
    ...option,
    className: `option-level${level}${className ? ` ${className}` : ''}`,
    as: (props) => <div {...props} ref={(el) => el?.style?.setProperty('padding', `4px ${25 * level}px`, 'important')} />
  });
  children && result.push(...convertToLinearOptions(children, level + 1));
  return result;
}, []);

const NestedDropdown = ({ options, isLoading, className, i18n, t, tReady, onKeyDown, ...props }) => {
  const [announcement, setAnnouncement] = useState('');
  const linearOptions = useMemo(() => (isLoading ?
    [{ key: 'loader', text: <div><Loader active inline='centered' /></div>, className: 'option-loader', disabled: true, selected: false }] :
    convertToLinearOptions(options)),
  [options, isLoading]
  );

  const handleKeyDown = (e) => {
    onKeyDown?.(e);
    const dropdown = e.currentTarget;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      requestAnimationFrame(() => {
        const name = dropdown.querySelector('.menu .item.selected')?.textContent?.trim();
        if (name) {
          setAnnouncement(name);
        }
      });
      return;
    }
    if ((e.key === 'Enter' || e.key === ' ') && dropdown.classList.contains('visible')) {
      e.preventDefault();
      dropdown.querySelector('.menu .item.selected:not(.disabled)')?.click();
    }
  };

  return (
    <>
      <Dropdown
        className={['nested-dropdown', className].filter((klass) => klass).join(' ')}
        options={linearOptions}
        {...props}
        onKeyDown={handleKeyDown} />
      <div aria-live='polite' className='sr-only'>{announcement}</div>
    </>
  );
};

export default NestedDropdown;

SatCoreRegister('NestedDropdown', NestedDropdown);
